import React, { PureComponent } from 'react'
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button
  } from 'reactstrap'

export default class UnpowerImageModal extends PureComponent {
  static defaultProps = {
    itemID: false,
    onConfirm: () => {},
    onCancel: () => {},
    headerLabel: 'Unpower Image?',
    confirmBtnLabel: 'Confirm',
    cancelBtnLabel: 'Cancel',
    confirmBtnClass: 'btn btn-primary',
    cancelBtnClass: 'btn btn-default',
    showCancel: true,
    submittingLabel: (
      <span>
        Unpowering... <i className="fa fa-cog fa-spin"/>
      </span>
    ),
  }

  constructor(props) {
    super(props)
    this.onConfirmClick = this.onConfirmClick.bind(this)
    this.onConfirmCancel = this.onConfirmCancel.bind(this)
  }

  onConfirmCancel() {
    this.props.onCancel()
  }

  onConfirmClick() {
      this.props.onConfirm(this.props.itemID)    
  }

  render() {
    const submitDisabled = this.props.buttonsDisabled
    const submitLabel = this.props.buttonsDisabled
      ? this.props.submittingLabel
      : this.props.confirmBtnLabel

    return (
        <Modal
            isOpen={this.props.open}
            toggle={this.toggle}
            className={this.props.className}
        >
            <ModalHeader toggle={this.props.onClose}>{this.props.headerLabel}</ModalHeader>
            <ModalBody>
                <div className="confirm-msg">Are you sure you want to unpower this image? This action cannot be undone.</div>
            </ModalBody>
            <ModalFooter>
            <Button
                color="secondary"
                onClick={this.props.onClose}
                disabled={submitDisabled}
            >
                {this.props.cancelBtnLabel}
            </Button>
            <Button
                color="primary"
                onClick={this.onConfirmClick}
                disabled={submitDisabled}
            >
                {submitLabel}
            </Button>
            </ModalFooter>
        </Modal>

    )
  }
}



// WEBPACK FOOTER //
// ./src/views/Components/Modals/UnpowerImageModal.js